import React from 'react';
import { Create, useNotify, useRedirect } from 'react-admin';
import { NEWS_POSTS_RESOURCE, formatDate } from '../common';
import NewsPostForm, { notifySaveError, stickyPreviewSx } from '../form/NewsPostForm';

/** Texto del banner del listado tras publicar, el mismo del prototipo validado. */
export const publishedMessage = (record) => {
    const when = record?.status === 'scheduled' ? 'Queda programada: ' : 'Ya está activa: ';
    return (
        `Publicada «${record?.title?.es ?? ''}». ${when}se mostrará como pop-up hasta 3 veces a cada usuario ` +
        `del ${formatDate(record?.starts_at)} al ${formatDate(record?.ends_at)}.`
    );
};

const NewsPostCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();

    // Como en el prototipo: vuelve al listado, que pinta el banner verde con `flash`.
    const onSuccess = (data) => {
        redirect('list', NEWS_POSTS_RESOURCE, undefined, undefined, { flash: publishedMessage(data) });
    };

    return (
        <Create title="Nueva publicación" mutationOptions={{ onSuccess, onError: notifySaveError(notify) }} sx={stickyPreviewSx}>
            <NewsPostForm isCreate />
        </Create>
    );
};

export default NewsPostCreate;
